<template>
  <Modal ref="modalRef" ok-text="Save" ok-close @ok="onOk">
    <template #title>Edit detail</template>
    <div class="fields">
      <label class="field">
        <span class="form-label">Type</span>
        <input type="text" class="form-control" v-model.trim="draftRef.type"/>
      </label>
      <label class="field">
        <span class="form-label">Date</span>
        <input type="text" class="form-control" v-model.trim="draftRef.date" placeholder="e.g. +1917-12-20"/>
      </label>
      <label class="field">
        <span class="form-label">Value</span>
        <input type="text" class="form-control" v-model.trim="draftRef.value"/>
      </label>
      <label class="field">
        <span class="form-label">Place</span>
        <input type="text" class="form-control" v-model.trim="draftRef.place"/>
      </label>
      <label class="field">
        <span class="form-label">Flag</span>
        <span class="flag-row">
          <input type="text" class="form-control flag-input" v-model.trim="draftRef.flag" placeholder="e.g. us" maxlength="6"/>
          <span v-if="draftRef.flag" class="fi" :class="`fi-${draftRef.flag}`"></span>
        </span>
      </label>
      <div class="form-check">
        <input id="detail-highlight" class="form-check-input" type="checkbox" v-model="draftRef.highlight"/>
        <label class="form-check-label" for="detail-highlight">Highlight</label>
      </div>
    </div>
    <template #secondaryContent>
      <button type="button" class="btn btn-outline-danger" @click="onDelete">Delete</button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { GameCardDetail } from './GamesApi'
import Modal from '@/util/Modal.vue'

const emit = defineEmits<{
  (e: 'save', detail: GameCardDetail): void
  (e: 'delete'): void
}>()

defineExpose({
  open: (detail: GameCardDetail) => {
    draftRef.value = { ...detail }
    modalRef.value?.open()
  },
  close: () => modalRef.value?.close(),
})

const draftRef = ref<GameCardDetail>({ type: '' })

const modalRef = ref<InstanceType<typeof Modal>>()

function onOk() {
  const draft = draftRef.value
  const detail: GameCardDetail = { type: draft.type }
  if (draft.date) {
    detail.date = draft.date
  }
  if (draft.value) {
    detail.value = draft.value
  }
  if (draft.place) {
    detail.place = draft.place
  }
  if (draft.flag) {
    detail.flag = draft.flag
  }
  if (draft.highlight) {
    detail.highlight = true
  }
  emit('save', detail)
}

function onDelete() {
  emit('delete')
}
</script>

<style lang="scss" scoped>
.fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .field {
    display: flex;
    flex-direction: column;
  }

  .flag-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .flag-input {
    width: 8rem;
  }

  .fi {
    font-size: 1.25rem;
  }
}
</style>
